import React from "react";
import cn from "classnames";
import { Preloader } from "../Preloader";

export const CardContentPreloader: React.FC = () => {
  return <Preloader size={"3x"} className={cn("my-10 text-gray-500")} />;
};
